import React from 'react';

const CardProductPerCategory = ({ img, alt, category }) => {

  return (
    <div className='card-ppc'>
      <div className="img-wrapper">
        <img src={img} alt={alt} />
      </div>
      <div className="card-desc">
        <p className="card-category">{category}</p>
        <p className='see-all-at-category'>Lihat Semua</p>
      </div>
    </div>
  )
}

export default CardProductPerCategory
